import { makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TaxiCompanyList } from '../../../../../services/taxi/GetDirectionAndFare/models/getFareSamplesParams';
import CautionsEN from './CautionsEN';
import CautionsJP from './CautionsJP';

export const useCautionStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    fontSize: '0.875rem',
    marginTop: '15px',
  },
  unorderedList: {
    paddingInlineStart: '20px',
  },
  redFont: {
    color: '#ff0000'
  },
  link: {
    textDecoration: 'underline',
    fontWeight: 'bold'
  },
  bold: {
    fontWeight: 'bold'
  },
  // TODO: 超やっつけなのでなんとかしたい
  come: {
    color: '#ff0000',
    marginLeft: '-15px'
  },
  comeBody: {
    color: '#ff0000',
    marginRight: '5px'
  },
  springMileMain: {
    color: '#FF0000'
  },
  springMileLeftMargin: {
    marginLeft: '1rem'
  }

}));

interface Props {
  isMeterFare: boolean,
  /** 仮予約画面で表示するタクシー会社名 */
  companyDisplayName: string,
  /** AMCをサポートする事業者の場合 */
  isSupportAMC?: boolean,
  /** 本予約画面か */
  isReservationPage?: boolean,
  /** タクシー会社 */
  company: TaxiCompanyList,
  /** 【AM-1152】マイル増量キャンペーン期間中か */
  isCampaignPeriod?: boolean,
  /** 【AM-1152】通常マイルあり（元々AMC ON）の会社か */
  isOriginalSupported?: boolean,
}

/** ハイヤー・タクシー予約画面の注意事項のコンポーネント。 */
export const Cautions: React.FC<Props> = (props: Props) => {
  const { i18n } = useTranslation();
  switch(i18n.language) {
    case 'en':
      return (
        <CautionsEN
          isMeterFare={props.isMeterFare}
          companyDisplayName={props.companyDisplayName}
          isSupportAMC={props.isSupportAMC}
          isReservationPage={props.isReservationPage}
          company={props.company}
        />
      );
    case 'ja':
    default:
      return (
        <CautionsJP
          isMeterFare={props.isMeterFare}
          companyDisplayName={props.companyDisplayName}
          isSupportAMC={props.isSupportAMC}
          isReservationPage={props.isReservationPage}
          company={props.company}
          isCampaignPeriod={props.isCampaignPeriod}
          isOriginalSupported={props.isOriginalSupported}
        />
      );
  }
}

export default Cautions;
